var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 8.09375L13.5 14.2812L26.2188 8.09375",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59375 10.5V1.90625C5.59375 1.14656 6.20906 0.53125 6.96875 0.53125H20.0313C20.7909 0.53125 21.4063 1.14656 21.4063 1.90625V10.5",
    stroke: "#192643",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4063 3.85713L25.2102 6.11901C25.8351 6.49095 26.2188 7.1647 26.2188 7.89207V18.406C26.2188 20.3042 24.6794 21.8435 22.7813 21.8435H4.21875C2.32056 21.8435 0.78125 20.3042 0.78125 18.406V7.89138C0.78125 7.16401 1.16419 6.49026 1.78981 6.11832L5.59375 3.85645",
    stroke: "#192643",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEmail);
export default __webpack_public_path__ + "static/media/open-email.9a06125255f75ad493a92cc81b286b21.svg";
export { ForwardRef as ReactComponent };